import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "value", "disabled", "onSelect", "dayInCurrentMonth", "disablePast", "disableFuture"];
import React from 'react';
import PropTypes from 'prop-types';
var DayView = function DayView(_ref) {
  var children = _ref.children,
    value = _ref.value,
    disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    dayInCurrentMonth = _ref.dayInCurrentMonth,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    other = _objectWithoutProperties(_ref, _excluded);
  var onSelectHandler = React.useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "presentation",
    onClick: dayInCurrentMonth && !disabled ? onSelectHandler : undefined,
    onKeyPress: dayInCurrentMonth && !disabled ? onSelectHandler : undefined
  }, other), children);
};
DayView.protoTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  onChange: PropTypes.func,
  onMonthChange: PropTypes.func,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired
};
DayView.defaultProps = {
  disablePast: false,
  disableFuture: false
};
export default DayView;